export const OPEN_CHAT_EVENT = "techizen:open-chat";

export const openTechizenChat = () => {
  window.dispatchEvent(new CustomEvent(OPEN_CHAT_EVENT));
};
